import {FC, ReactNode, useEffect, useRef, useState} from 'react';
import {twMerge} from 'tailwind-merge';

export type ModalBodyProps = {
    children: ReactNode;
    className?: string;
};

const ModalBody: FC<ModalBodyProps> = ({children, className}) => {
    const [isOverflowing, setIsOverflowing] = useState(false);

    const styleHeight =
        className && className.includes('h-') ? null : ' max-h-[24.75rem]'; // 25rem is "small"

    const contentRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (contentRef.current) {
            const onResize = () => {
                const {current} = contentRef;

                if (current) {
                    setIsOverflowing(
                        current.clientHeight < current.scrollHeight,
                    );
                }
            };

            onResize();
            window.addEventListener('resize', onResize);

            return () => {
                window.removeEventListener('resize', onResize);
            };
        }

        return undefined;
    }, [contentRef]);

    return (
        <div
            ref={contentRef}
            className={twMerge(
                styleHeight,
                'min-h-4 overflow-y-auto px-4 py-2',
                isOverflowing && 'border-b border-grey-300',
                className,
            )}
        >
            {children}
        </div>
    );
};

export default ModalBody;
